import { Navigate, useLocation, useParams } from "react-router-dom";

/**
 * LegacyRedirect
 *
 * Redirect que preserva `search` (query string) e `hash` da URL de origem.
 * Use no lugar de `<Navigate to="..." replace />` sempre que a rota antiga
 * puder receber parâmetros relevantes (UTMs, filtros, âncoras, tokens, etc.).
 *
 * Para rotas com params dinâmicos (`:id`, `:slug`), passe `to` como função
 * que recebe os params atuais e retorna o novo pathname.
 *
 * Exemplos:
 *   <LegacyRedirect to="/central-encontros" />
 *   <LegacyRedirect to={(p) => `/professor/${p.id}`} />
 */
type LegacyRedirectProps = {
  to: string | ((params: Record<string, string | undefined>) => string);
};

export const LegacyRedirect = ({ to }: LegacyRedirectProps) => {
  const location = useLocation();
  const params = useParams();
  const pathname = typeof to === "function" ? to(params) : to;

  // Guard defensivo: nunca redirecionar para o mesmo pathname (evita loop).
  if (pathname === location.pathname) {
    return null;
  }

  return (
    <Navigate
      to={{ pathname, search: location.search, hash: location.hash }}
      replace
    />
  );
};
